import React, { useState, useEffect } from "react";
import Sidebar from "./sidebar/Sidebar";
import axios from "axios";
import api from "../api/axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function Project() {
  const navigate = useNavigate();
  const [sidebarToggle, setSidebarToggle] = useState(true);
  const [filteredProject, setFilteredProject] = useState([]);
  const [projectData, setProjectData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [inputdata, setInputdata] = useState("");
  const [deletePopup, setDeletePopup] = useState(false);
  const [deleteID, setDeleteID] = useState(null);
  // const [activeButton, setActiveButton] = useState("Orders");
  const [userdata, setUserdata] = useState([]);

  const fetchuserdata = async () => {
    try {
      const res = await api.get("/order");
      setUserdata(res.data);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    fetchuserdata();
  }, []);

  //fetch data
  const fetchprojectdata = async () => {
    const res = await api.get("/getproject");
    setProjectData(res.data);
  };

  useEffect(() => {
    fetchprojectdata();
  }, []);


  //sidebar toggle
  const toggleClick = () => {
    setSidebarToggle(!sidebarToggle);
  };

  const handleFilterChange = (e) => {
    setInputdata(e.target.value);
  };



  const handleFilterSubmit = (e) => {
    e.preventDefault();
    const fdata = projectData.filter((user) => {
      return (
        (user.projectid?.toString() || "").includes(inputdata) ||
        (user.projectname?.toString() || "").includes(inputdata) ||
        (user.locationURL?.toString() || "").includes(inputdata) ||
        (user.methodology?.toString() || "").includes(inputdata) ||
        (user.credits?.toString() || "").includes(inputdata) ||
        (user.price?.toString() || "").includes(inputdata)
      );
    });
    setFilteredProject(fdata);
  };

  //pagination
  const recordPerPage = 10;
  const lastIndex = currentPage * recordPerPage;
  const firstIndex = lastIndex - recordPerPage;
  const records = projectData.slice(firstIndex, lastIndex);
  const npage = Math.ceil(projectData.length / recordPerPage);

  const prevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const nextPage = () => {
    if (currentPage < npage) setCurrentPage(currentPage + 1);
  };

  const handleRefresh = () => {
    setInputdata("");
    setFilteredProject([]);
  };

  const handleAddProject = () => {
    navigate("/project/addnewproject");
  };

  const handleEdit = (id) => {
    const dataToEdit = projectData.find((user) => user._id === id);
    if (!dataToEdit) {
      console.error("projectdata not found!");
      return;
    }
    navigate("/project/addnewproject", { state: { data: dataToEdit } });
  };

  const handleViewClick = (id) => {
    const dataToView = projectData.find((user) => user._id === id);
    if (!dataToView) {
      console.error("projectdata not found!");
      return;
    }
    const allCarts = userdata.filter(order =>
      (order.orderDetails || []).find(details =>
        (details.usercart || []).find(cart => cart.projectname === dataToView.projectname)
      ))
    navigate("/project/viewproject", {
      state: {
        project: dataToView,
        orders: allCarts,
      },
    });
  };

  const handleDelete = (id) => {
    setDeletePopup(true);
    setDeleteID(id);
  };

  const handleDeleteData = async (id) => {
    try {
      await api.delete(`/deleteproject/${id}`);
      toast.success("project delete successfully");
      setDeletePopup(false);
      await fetchprojectdata();
    } catch (error) {
      console.error(error);
    }
  };


  return (
    <>
      {/* header section-1 */}
      <div className="font-[Poppins] flex ">
        {sidebarToggle ? <div className="w-[320px] nirav"></div> : null}
        <Sidebar toggleClick={toggleClick} sidebarToggle={sidebarToggle} />
        <div className="w-[100%] ">
          <div className=" 2xl:w-[90%] w-[95%] m-auto 2xl:mt-16 mt-10  xl:p-2 lg:p-10  p-2">
            <div className="sm:flex sm:justify-between sm:items-center">
              <h1 className="font-medium 2xl:text-2xl text-xl">
                Hello Admin 👋🏼
              </h1>
            </div>

            {/* section-3 */}
            <div className="border mt-5 2xl:rounded-[30px] rounded-[20px] px-10 py-8  bg-white shadow-sm">
              <div className="mx-2 my-2 flex flex-wrap justify-between items-center">
                <div className="mb-3">
                  <h1 className="font-semibold 2xl:text-2xl text-xl">
                    Project
                  </h1>
                </div>
                {/* filter table data form */}
                <div className="flex items-center flex-wrap gap-1">
                  <form
                    className="filterinput"
                    action=""
                    onSubmit={handleFilterSubmit}
                  >
                    <input
                      onChange={handleFilterChange}
                      type="text"
                      name="inputdata"
                      className="bg-[#F9FBFF]  sm:px-5 max-sm:w-[68%] pl-3 2xl:py-2 py-[0.40rem] border border-gray-300  outline-none focus:ring-2 focus:ring-[#C65B1D] rounded-lg text-xs max-md:my-1"
                      placeholder="Search"
                    />
                    <button
                      type="submit"
                      className="mr-1 ml-3 cursor-pointer bg-[#C65B1D]  hover:shadow-md button text-white py-[0.4rem] 2xl:text-sm text-xs rounded-lg 2xl:px-3 px-2"
                    >
                      Search
                    </button>
                  </form>

                  <button
                    onClick={handleAddProject}
                    className="mr-1 ml-3 cursor-pointer bg-[#C65B1D]  hover:shadow-md button text-white py-[0.4rem] 2xl:text-sm text-xs rounded-lg 2xl:px-3 px-2"
                  >
                    Add Project
                  </button>

                  <div className="flex justify-between items-center flex-wrap">
                    <i
                      onClick={handleRefresh}
                      className="fa-solid fa-arrows-rotate ml-2 cursor-pointer border border-gray-300 px-2 2xl:py-[0.45rem] py-[0.40rem] rounded-md bg-[#F9FBFF]"
                    ></i>
                  </div>
                </div>
              </div>

              {deletePopup && (
                <div className="fixed inset-0 top-0 left-0 w-screen h-screen z-[9999]  flex items-center justify-center bg-black bg-opacity-50">
                  <div className="bg-white p-6 rounded shadow-lg">
                    <p className="mb-4">
                      Are you sure you want to delete this item?
                    </p>
                    <div className="flex  justify-stretch gap-4">
                      <button
                        className="px-4 py-2 w-full bg-gray-300 rounded"
                        onClick={() => setDeletePopup(false)}
                      >
                        No
                      </button>
                      <button
                        className="px-4 py-2 w-full bg-[#E84000] text-white rounded"
                        onClick={() => handleDeleteData(deleteID)}
                      >
                        Yes
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* section-4 table */}
              <div className="mt-6 relative overflow-x-auto  overflow-y-hidden">
                <table className="w-full border-collapse border-spacing-0">
                  <thead>
                    <tr className="text-[#b5b7c0] m-12 font-medium">
                      <th className="whitespace-nowrap">Sr no</th>
                      <th className="whitespace-nowrap">Project ID</th>
                      <th className="whitespace-nowrap">Project Name</th>
                      <th className="whitespace-nowrap">URL</th>
                      <th className="whitespace-nowrap">Methodology</th>
                      <th className="whitespace-nowrap">Credits Available</th>
                      <th className="whitespace-nowrap">Credit Price</th>
                      <th className="whitespace-nowrap">Action</th>
                      {/* <th></th>  */}
                    </tr>
                  </thead>
                  <tbody>
                    {(filteredProject.length > 0
                      ? filteredProject
                      : records
                    ).map((data, index) => {
                      return (
                        <React.Fragment key={index}>
                          <tr >
                            <td>{index + 1}</td>
                            <td
                              className="font-bold underline text-[#0167FF] whitespace-nowrap"
                              onClick={() => handleViewClick(data._id)}
                              style={{ cursor: "pointer" }}
                            >
                              {data.projectid}
                            </td>
                            <td>{data.projectname}</td>
                            <td>{data.locationURL || "-"}</td>
                            <td>{data.methodology}</td>
                            <td>{data.avalableCredits}</td>
                            <td>{data.price}</td>
                            <td className="">
                              <i
                                onClick={() => handleEdit(data._id)}
                                className="fa-solid cursor-pointer fa-pen-to-square text-[#B5B7C0]"
                              ></i>
                              <i
                                onClick={() => handleDelete(data._id)}
                                className="fa-solid cursor-pointer fa-trash-can text-[#B5B7C0] ml-4"
                              ></i>
                            </td>
                          </tr>
                          {/* {expendedRow === index && (
                            <>
                              <tr>
                                <td colSpan="12">
                                  <div className="flex gap-6 mt-2">
                                    <button
                                      onClick={() => setActiveButton("Vintage")}
                                      className={`${
                                        activeButton === "Vintage"
                                          ? " text-[#C65B1D] e"
                                          : "text-[#4D4D4D]  "
                                      } font-medium text-sm leading-5 cursor-pointer `}
                                    >
                                      Vintage
                                    </button>

                                    <button
                                      onClick={() => setActiveButton("Orders")}
                                      className={`${
                                        activeButton === "Orders"
                                          ? " text-[#C65B1D] e "
                                          : "text-[#4D4D4D]  "
                                      } font-medium text-sm leading-5 cursor-pointer `}
                                    >
                                      Orders
                                    </button>

                                    <button
                                      onClick={() => setActiveButton("Address")}
                                      className={`${
                                        activeButton === "Address"
                                          ? " text-[#C65B1D] e "
                                          : "text-[#4D4D4D]  "
                                      } font-medium text-sm leading-5 cursor-pointer `}
                                    >
                                      Address
                                    </button>
                                  </div>

                                  <section className="mt-4">
                                    {activeButton === "Vintage" && (
                                      <table className="min-w-[100%] table-auto border border-[#E5E5E5] border-separate border-spacing-0 rounded-t-lg shadow-sm">
                                        <thead className="bg-[#FCFCFC] rounded-t-lg">
                                          <tr className="">
                                            <th
                                              className={`whitespace-nowrap p-2 pl-4 rounded-tl-lg   border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="border-r pr-8 border-[#E5E5E5]">
                                                Vintage
                                              </div>
                                            </th>
                                            <th
                                              className={`whitespace-nowrap p-2 pl-0 border-b  border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="border-r pr-8  border-[#E5E5E5]">
                                                Batch ID
                                              </div>
                                            </th>
                                            <th
                                              className={`whitespace-nowrap p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="border-r pr-8  border-[#E5E5E5]">
                                                Credit ID
                                              </div>
                                            </th>
                                            <th
                                              className={`whitespace-nowrap  p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="border-r pr-8  border-[#E5E5E5]">
                                                Credits (tCO2eq)
                                              </div>
                                            </th>
                                            <th
                                              className={`whitespace-nowrap p-2 pl-0 rounded-tr-lg  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="  border-[#E5E5E5]">
                                                Credit Price
                                              </div>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody></tbody>
                                      </table>
                                    )}

                                    {activeButton === "Orders" && (
                                      <table className="min-w-[100%] table-auto border border-[#E5E5E5] border-separate border-spacing-0 rounded-t-lg shadow-sm">
                                        <thead className="bg-[#FCFCFC] rounded-t-lg">
                                          <tr className="">
                                            <th
                                              className={`whitespace-nowrap p-2 pl-4 rounded-tl-lg w-[100px]  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="border-r pr-8 border-[#E5E5E5]">
                                                Order ID
                                              </div>
                                            </th>
                                            <th
                                              className={`whitespace-nowrap p-2 pl-0 border-b w-[150px] border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="border-r pr-8  border-[#E5E5E5]">
                                                Order Date
                                              </div>
                                            </th>
                                            <th
                                              className={`whitespace-nowrap p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="border-r pr-8  border-[#E5E5E5]">
                                                SKU ID
                                              </div>
                                            </th>
                                            <th
                                              className={`whitespace-nowrap  p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="border-r pr-8  border-[#E5E5E5]">
                                                Transaction ID
                                              </div>
                                            </th>

                                            <th
                                              className={`whitespace-nowrap p-2  pl-0 w-[200px] border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="border-r pr-8  border-[#E5E5E5]">
                                                Credits
                                              </div>
                                            </th>
                                            <th
                                              className={`whitespace-nowrap p-2 w-[200px] pl-0 border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="border-r pr-8  border-[#E5E5E5]">
                                                Total Amount
                                              </div>
                                            </th>

                                         
                                            <th
                                              className={`whitespace-nowrap p-2 pl-0 rounded-tr-lg  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="  border-[#E5E5E5]">
                                                Receipt
                                              </div>
                                            </th>
                                            <th
                                              className={`whitespace-nowrap p-2 pl-0 rounded-tr-lg  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="  border-[#E5E5E5]"></div>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody></tbody>
                                      </table>
                                    )}

                                    {activeButton === "Address" && (
                                      <table className="min-w-[100%] table-auto border border-[#E5E5E5] border-separate border-spacing-0 rounded-t-lg shadow-sm">
                                        <thead className="bg-[#FCFCFC] rounded-t-lg">
                                          <tr className="">
                                            <th
                                              className={`whitespace-nowrap p-2 pl-4 rounded-tl-lg   border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="border-r pr-8 border-[#E5E5E5]">
                                                Address
                                              </div>
                                            </th>
                                            <th
                                              className={`whitespace-nowrap p-2 pl-0 border-b  border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="border-r pr-8  border-[#E5E5E5]">
                                                State
                                              </div>
                                            </th>
                                            <th
                                              className={`whitespace-nowrap p-2 pl-0  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="border-r pr-8  border-[#E5E5E5]">
                                                City
                                              </div>
                                            </th>

                                            <th
                                              className={`whitespace-nowrap p-2 pl-0 rounded-tr-lg  border-b border-[#E5E5E5] text-sm text-[#1A1A1A] leading-5  max-xl:text-xs font-medium text-start `}
                                            >
                                              <div className="  border-[#E5E5E5]">
                                                Pincode
                                              </div>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <td>{data.address}</td>
                                          <td>{data.state}</td>
                                          <td>{data.city}</td>
                                          <td>{data.pincode}</td>
                                        </tbody>
                                      </table>
                                    )}
                                  </section>
                                </td>
                              </tr>
                            </>
                          )} */}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* pagination */}
              <div className="flex justify-between items-center mt-4">
                <button
                  onClick={prevPage}
                  disabled={currentPage === 1}
                  className={`px-4 py-2 bg-[#C65B1D] hover:bg-[#C65B1D] text-white rounded-lg mr-2 transition duration-200 ease-in-out ${currentPage === 1
                    ? "opacity-50 cursor-not-allowed"
                    : "cursor-pointer"
                    }`}
                  aria-label="Previous Page"
                >
                  Prev
                </button>

                <button
                  onClick={nextPage}
                  disabled={currentPage === npage}
                  className={`px-4 py-2 bg-[#C65B1D] hover:bg-[#C65B1D] text-white rounded-lg ml-2 transition duration-200 ease-in-out ${currentPage === npage
                    ? "opacity-50 cursor-not-allowed"
                    : "cursor-pointer"
                    }`}
                  aria-label="Next Page"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Project;
